import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {NotificationProvider} from '../../../models/notificationProvider';
import {User} from '../../../models/user';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  @Input() user: User;
  @Input() providers: NotificationProvider[];
  @Input() mode: string;
  @Output() closeWindow: EventEmitter<boolean> = new EventEmitter<boolean>();
  firstPassword: string;
  firstNameErrorMessage = '';
  lastNameErrorMessage = '';
  emailErrorMessage = '';
  passwordErrorMessage = '';
  phoneErrorMessage = '';
  providerErrorMessage = '';
  firstNameHelpHint = 'Εισάγετε το όνομά σας. Το πεδίο δεν θα πρέπει να είναι κενό';
  lastNameHelpHint = 'Εισάγετε το επώνυμό σας. Το πεδίο δεν θα πρέπει να είναι κενό';
  emailHelpHint = 'Επιλέξτε το email που θα χρησιμοποιείτε για την σύνδεσή σας στην εφαρμογή. Το πεδίο δεν θα πρέπει να είναι κενό';
  passwordHelpHint = 'Αλλάξτε τον προσωρινό κωδικό σας';
  phoneHelpHint = 'Εισάγετε το τηλέφωνό σας. Το πεδίο δεν θα πρέπει να είναι κενό';
  providersHelpHint = 'Επιλέξτε τον τρόπο που θα λαμβάνετε ειδοποιήσεις από την εφαρμογή';
  selectedProvider: NotificationProvider;

  constructor(public commonService: CommonService, public toastMessagesService: ToastMessagesService, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.firstPassword = this.user.password;
    const provider = this.providers.find(p => +p.id === +this.user.notification_providers);
    this.user.notification_providers = provider ? provider : null;
  }

  getEmailOptions() {
    if (this.mode === 'preview') {
      return this.user.email;
    } else {
      if (!this.user.declared_emails) {
        if (this.user.email) {
          return [this.user.email];
        }
      } else {
        return this.user.declared_emails.split(';');
      }
    }

  }

  async validate() {
    this.firstNameErrorMessage = this.user.first_name ? `` : `* Υποχρεωτικό πεδίο`;
    this.lastNameErrorMessage = this.user.last_name ? `` : `* Υποχρεωτικό πεδίο`;
    this.emailErrorMessage = this.user.email ? `` : `* Υποχρεωτικό πεδίο`;
    // this.passwordErrorMessage = this.validateChangedPassword();
    this.phoneErrorMessage = this.user.telephone ? `` : `* Υποχρεωτικό πεδίο`;
    this.providerErrorMessage = this.user.notification_providers ? `` : `* Υποχρεωτικό πεδίο`;

    if (!this.firstNameErrorMessage && !this.lastNameErrorMessage && !this.emailErrorMessage && !this.passwordErrorMessage
      && !this.phoneErrorMessage && !this.providerErrorMessage) {
      await this.updateUserInfo();
    } else {
      return false;
    }
  }

  async updateUserInfo() {
    try {
      console.log(this.user);
      await this.commonService.updateItem(`people/parent`, this.user);
      this.toastMessagesService.toastMessages(`Η διαμόρφωση ολοκληρώθηκε με επιτυχία`);
      this.closeWindow.emit(true);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  validateChangedPassword(): string {
    if (this.user.password) {
      return this.firstPassword === this.user.password ? '* Πρέπει να αλλάξετε κωδικό' : '';
    } else {
      return `* Υποχρεωτικό πεδίο`;
    }
  }
}
